import React from 'react'
import CanadaTemplateDefault from 'src/components/template/ca/'
import { canadaPlanSet, canadaSports_EPL_UCL_Override } from 'src/constants/planData/canadaPlanData'
import { videos } from 'src/constants/videos'
import { subtitleText } from 'src/modules/utils/constants'

export default (props) => {
  return (
    <CanadaTemplateDefault
      location={props.location}
      lang="en"
      market="canada"
      video={videos.canada_seriea.videoUrl}
      title="Watch Italian soccer with Fubo"
      subtitle={subtitleText.epl}
      networkSet="canada_sports"
      planCardsConfig={{
        plans: canadaPlanSet.sports,
        overrides: canadaSports_EPL_UCL_Override,
      }}
    />
  )
}
